import { Component, Input, ViewChild } from '@angular/core';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';

@Component({
  selector: 'app-datepicker-toggler',
  template: `
    <mat-datepicker-toggle #datepickerToggle matSuffix [for]="datepicker">
      <span class="toggler-icon" matDatepickerToggleIcon></span>
    </mat-datepicker-toggle>
  `,
  styleUrls: ['./datepicker-toggler.component.scss'],
})
export class DatepickerTogglerComponent {
  @Input() datepicker: MatDatepicker<any>;
  @ViewChild('datepickerToggle') datepickerToggle: MatDatepickerToggle<any>;
}
